import PropTypes from 'prop-types';

export default PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']);